import { render, staticRenderFns } from "./ResultSingle.vue?vue&type=template&id=96555bce"
import script from "./ResultSingle.vue?vue&type=script&lang=js"
export * from "./ResultSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports